<template>
  <div class="home">
    <portnavbar :navbar-content="navbarcontent"></portnavbar>
    <portbanner :banner-content="bannercontent"></portbanner>
    <portabout :data="aboutcontents"></portabout>
    <portcapabilities :data="capabilitiescontents"></portcapabilities>
    <portskills :data="skillscontents"></portskills>
    <portprojects :data="projcontents"></portprojects>
    <!-- <portcontactform></portcontactform> -->
    <portcta :data="ctacontents"></portcta>
    <portfooter :footer-content="footercontent"></portfooter>
  </div>
</template>

<script>
// @ is an alias to /src
import portnavbar from "@/components/portnavbar.vue";
import portbanner from "@/components/portbanner.vue";
import portabout from "@/components/portabout.vue";
import portcapabilities from "@/components/portcapabilities.vue";
import portskills from "@/components/portskills.vue";
import portprojects from "@/components/portprojects.vue";
import portcta from "@/components/portcta.vue";
import portfooter from "@/components/portfooter.vue";
// import portcontactform from "@/components/portcontactform.vue";


export default {
  name: "Home",
  components: {
    portnavbar,
    portbanner,
    portabout,
    portcapabilities,
    portskills,
    portprojects,
    portcta,
    portfooter,
    // portcontactform
  },
  data: () => ({
    navbarcontent: [
      {
        text: "ABOUT ME",
        url: "/#about-me"
      },{
        text: "WHAT I BRING",
        url: "/#capabilities"
      },{
        text: "SKILLS",
        url: "/#skills"
      },{
        text: "PROJECTS",
        url: "/#projects",
      },{
        text: "CONTACT ME",
        url: "/#contact-me",
      }
    ],
    bannercontent: {
      img:"/img/port-img.png",
      title: "Web Developer · Project Manager",
      name: "Juanito L. Parafina III",
      subtitle: "I’m a web developer and project manager with <strong>9+ years of experience</strong> working on websites from initial requirements through development, QA, launch, and ongoing improvements.",
      fontawesomeclass:'fas fa-laptop-code'
    },
    aboutcontents: {
      label: "About me",
      title: "I like figuring things out.",
      paginationLabel: "About section slides",
      intro: [
        "I’m a web developer and project lead with 9+ years of experience working on websites for businesses across healthcare, education, professional services, e-commerce, and more.",
        "Over the years, my role has grown from development into project management and team leadership. I’ve worked directly with clients to understand what they need, helped shape project requirements, coordinated designers and developers, worked through content and technical decisions, managed QA, and helped bring projects through to launch.",
        "I enjoy the part where a project starts out as a collection of ideas, requirements, and problems, and gradually becomes something clear, organized, and useful.",
      ],
      stats: [
        { target: 40, suffix: "+", label: "projects led" },
        { target: 150, suffix: "+", label: "websites supported" },
      ],
      cards: [
        {
          title: "Clarity before complexity.",
          icon: "fas fa-compass",
          paragraphs: [
            "I like to understand the goal before jumping into the solution. I look at the business, the audience, the requirements, and the people involved so we can figure out what actually needs to happen.",
            "Whether it’s content, design, development, or scope, I like finding the simplest approach that gets the job done well.",
          ],
        },
        {
          title: "Good work gets better when people work together.",
          icon: "fas fa-users",
          paragraphs: [
            "I enjoy brainstorming, sharing ideas, and figuring things out with other people. Different perspectives often lead to better solutions.",
            "As a project manager, I keep priorities, expectations, and deliverables aligned while supporting the team through the work. I also enjoy mentoring, reviewing work, and finding ways to make our processes better.",
          ],
        },
        {
          title: "Still curious.",
          icon: "fas fa-lightbulb",
          paragraphs: [
            "Outside of work, I like travelling, discovering new places, and trying things I haven’t done before.",
            "That curiosity follows me into my work too. I’m always looking for a better way to solve a problem, improve a process, or learn something new.",
            "I don’t think you ever completely figure it out, and that’s part of what makes the work interesting.",
          ],
        },
      ],
    },
    skillscontents: {
    langtoolstitle:"Tools & Skills",
      tabstitlecontents: [
        {
          tabtitle:'Frontend',
          tabtitleclass:'nav-link active',
          tabtitlelink:'#tabs-1'
        }, {
          tabtitle:'Backend',
          tabtitleclass:'nav-link ',
          tabtitlelink:'#tabs-2'
        }, {
          tabtitle:'Project Management',
          tabtitleclass:'nav-link ',
          tabtitlelink:'#tabs-3'
        }, {
          tabtitle:'CRM & Automation',
          tabtitleclass:'nav-link ',
          tabtitlelink:'#tabs-6'
        }, {
          tabtitle:'Deployment / Tools',
          tabtitleclass:'nav-link ',
          tabtitlelink:'#tabs-4'
        }, {
          tabtitle:'Software / Hardware',
          tabtitleclass:'nav-link ',
          tabtitlelink:'#tabs-5'
        }
      ],
      tabscontent: [
        {
          tabcontentclass:'tab-pane active',
          tabcontentid:'tabs-1',
          contents: [
            {
              content:'PSD to Wordpress',
              fontawesomeclass:'fab fa-wordpress wp-c',
              progressbarid:'seventy',
              percentagecontent:'70%'
              
            },{
              content:'PSD to Vue Js / Vue Bootstrap Panel Components',
              fontawesomeclass:'fab fa-vuejs vue-c',
              progressbarid:'fifty',
              percentagecontent:'50%'
            },{
              content:'PSD to Angular 8 - 9 / Angular Material Panel Components',
              fontawesomeclass:'fab fa-angular ng-c',
              progressbarid:'fifty',
              percentagecontent:'50%'
            },{
              content:'jQuery / Javascript / Typescript',
              fontawesomeclass:'fab fa-js js-c',
              progressbarid:'fifty',
              percentagecontent:'50%'
            },{
              content:'PSD to HTML5',
              fontawesomeclass:'fab fa-html5 html-c',
              progressbarid:'eighty',
              percentagecontent:'80%'
            },{
              content:'Bootstrap',
              fontawesomeclass:'fab fa-bootstrap boots-c',
              progressbarid:'eighty',
              percentagecontent:'80%'
            },{
              content:'CSS3',
              fontawesomeclass:'fab fa-css3-alt css-c',
              progressbarid:'eighty',
              percentagecontent:'80%'
            },{
              content:'SASS/SCSS',
              fontawesomeclass:'fab fa-sass sass-c',
              progressbarid:'seventy',
              percentagecontent:'70%'
            }
          ]
        },{
          tabcontentclass:'tab-pane ',
          tabcontentid:'tabs-6',
          contents: [
            {
              content:'HubSpot',
              imgsrc:'https://cdn.simpleicons.org/hubspot/FF7A59',
              fontawesomeclass:'fas fa-chart-line default-c',
              progressbarid:'sixty',
              percentagecontent:'60%'
            },{
              content:'GoHighLevel',
              imgsrc:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAABCFBMVEUIIj0ACUZKTS3/1gBT5iUdWjYABkAJJT0vq/8CDRv/4wAAA0B5bSEABEgjaTRV7SQEFz4ZXp8JJjwwrv8aY6gAGz8AAEr/6AAAAEIvijD//wD/5AAzuf8RRG8CDR8AGkAAFEIDFT+tkBXKrQ4ADkQ9riw5oS6JeB3/8AC2mxMDFD81mC5b/SOBciD/ygD/wwGkjxZK0CgsgjGdhRoVHj8WKjpyZSZuXimQgxsrOzQQNztVzzhVxj4kajENMDsAAFNfxU8YNkkUTocfUj8sov8OOWcBBhBS6SIAACYole0AABh1XgkAFFgplPsGJXMeVhcAYd4bc/Elc0Z7dS4EFCkAADIMMVYcWDdvm272AAABWUlEQVQ4jc3Ra1eCMBgH8IHIGBcd4ABNBS+pKUZ4Ky2zDLWLdDHT7/9N4tg5mUK9zefVc7bf9vzPBsABFSQm3PYEhvZNE1vKV68UMMZ7AmKtWCqXNwJa7HHFKMDd81pVr51QVrAK60bDttPGzzsg0Zr6qVM70ywIsZG2XdduGdtMgFjtDO84sUypgwmp2IzrJu1GnXwDs1vttR2neH7Rr+NBOtG4vGoNW9d4OwJQo37MoUcSQagjSHHm5lZgwU5Mio7xPQmgyRgBIZFk7sp77xAAXdQQ8LKTaQBmcSEMePEePHCeN3kMboizYXD0NPdU3+fU55dowIuvnh+U97ZgosH7PC/7vrycL2bRI0R2Kqv+ePrxSwZelJCscjIS/gIcl/pPoG9CqhswiwB6ramhVDabQsbQtkN/Qbo03TfBKpdbATJYr6/JHlAIZRQUsMznl0DBgmAq4HDqE4tuKwUbcZKlAAAAAElFTkSuQmCC',
              fontawesomeclass:'fas fa-bullseye default-c',
              progressbarid:'sixty',
              percentagecontent:'60%'
            }
          ]
        },{
          tabcontentclass:'tab-pane ',
          tabcontentid:'tabs-2',
          contents: [
            {
              content:'PHP',
              fontawesomeclass:'fab fa-php php-c',
              progressbarid:'eighty',
              percentagecontent:'80%'
            }, {
              content:'MySQL / MariaDB',
              fontawesomeclass:'fas fa-database default-c',
              progressbarid:'fifty',
              percentagecontent:'50%'
            }
          ]
        },{
          tabcontentclass:'tab-pane ',
          tabcontentid:'tabs-3',
          contents: [
            {
              content:'ClickUp',
              imgsrc:'https://cdn.simpleicons.org/clickup/7B68EE',
              fontawesomeclass:'fas fa-clipboard-check default-c',
              progressbarid:'seventy',
              percentagecontent:'70%'
            },{
              content:'Asana',
              imgsrc:'https://cdn.simpleicons.org/asana/FF6B6B',
              fontawesomeclass:'fab fa-asana default-c',
              progressbarid:'seventy',
              percentagecontent:'70%'
            },{
              content:'Trello',
              imgsrc:'https://cdn.simpleicons.org/trello/0055CC',
              fontawesomeclass:'fab fa-trello trello-c',
              progressbarid:'seventy',
              percentagecontent:'70%'
            },{
              content:'BaseCamp',
              imgsrc:'https://cdn.simpleicons.org/basecamp/8B7A5E',
              fontawesomeclass:'fab fa-basecamp default-c',
              progressbarid:'seventy',
              percentagecontent:'70%'
            }
          ]
        },{
          tabcontentclass:'tab-pane ',
          tabcontentid:'tabs-4',
          contents: [
            {
              content:'NPM',
              fontawesomeclass:'fab fa-npm npm-c',
              progressbarid:'seventy',
              percentagecontent:'70%'
            },{
              content:'SSH / FTP / SFTP',
              fontawesomeclass:'fas fa-terminal default-c',
              progressbarid:'ninety',
              percentagecontent:'90%'
            },{
              content:'Git',
              fontawesomeclass:'fas fa-code-branch git-c',
              progressbarid:'seventy',
              percentagecontent:'70%'
            },{
              content:'Website / Domain Hosting / Email',
              fontawesomeclass:'fas fa-server server-c',
              progressbarid:'eighty',
              percentagecontent:'80%'
            }
          ]
        },{
          tabcontentclass:'tab-pane ',
          tabcontentid:'tabs-5',
          contents: [
            {
              content:'Office Work',
              fontawesomeclass:'fas fa-keyboard office-c',
              progressbarid:'eighty',
              percentagecontent:'80%'
            },{
              content:'Computer Software/Hardware Installation/Troubleshooting',
              fontawesomeclass:'fas fa-microchip default-c',
              progressbarid:'ninety',
              percentagecontent:'90%'
            },{
              content:'Computer Troubleshooting',
              fontawesomeclass:'fas fa-exclamation-triangle trouble-c',
              progressbarid:'ninety',
              percentagecontent:'90%'
            }
          ]
        }
      ]
    },
    capabilitiescontents: {
      title: "What I bring to a project.",
      subtitle: "From the first conversation to the final QA, my experience on both sides of a project helps me understand the challenges developers face while keeping sight of the client’s goals and the bigger picture.",
      paginationLabel: "Capability slides",
      items: [
      {
        title: "Project management",
        description: "Coordinating people, requirements, priorities, timelines, and deliverables.",
        icon: "fas fa-briefcase",
      },
      {
        title: "Client communication",
        description: "Understanding requirements, managing feedback, and keeping expectations aligned.",
        icon: "fas fa-comments",
      },
      {
        title: "Web development",
        description: "Building responsive WordPress websites, landing pages, and reusable front-end components.",
        icon: "fas fa-laptop-code",
      },
      {
        title: "On-page SEO",
        description: "Creating a solid foundation for search engines and users.",
        icon: "fas fa-search",
      },
      {
        title: "QA & troubleshooting",
        description: "Reviewing the details, finding problems, and making sure things work before launch.",
        icon: "fas fa-bug",
      },
      {
        title: "Launch & support",
        description: "Coordinating the final steps and supporting websites after they go live.",
        icon: "fas fa-rocket",
      },
      ],
    },
    projcontents: {
      title: "A few places I’ve helped build and lead.",
      subtitle: "Great design starts with clarity, collaboration, and strong digital leadership.",
      tabstitlecontents: [
        {
          tabtitle:'Wordpress',
          tabtitleclass:'nav-link active',
          tabtitlelink:'#projtabs-1'
        }, {
          tabtitle:'Angular 8-9',
          tabtitleclass:'nav-link ',
          tabtitlelink:'#projtabs-2'
        }, {
          tabtitle:'Vue.js',
          tabtitleclass:'nav-link ',
          tabtitlelink:'#projtabs-3'
        }
      ],
      tabscontent: [
        {
          tabcontentclass:'tab-pane active',
          tabcontentid:'projtabs-1',
          contents: [
            {
              projectimg:'../img/smartperformance.jpg',
              projecttitle:'Smart Performance',
              projecttype:'Health & Performance Website',
              projectyear:'2026',
              projectposition:'Lead Developer / Project Manager',
              projectlink:'https://smartperformance.ca/',
              projectsummary:'Health and performance business website focused on wellness, service credibility, and customer conversion.',
              projecthosting:'Pressable',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','https://bricksbuilder.io/wp-content/uploads/2023/07/bricks-logo.svg']
            },
            {
              projectimg:'../img/krakensec.jpg',
              projecttitle:'Kraken Security',
              projecttype:'Security Services Website',
              projectyear:'2026',
              projectposition:'Lead Developer / Project Manager',
              projectlink:'https://www.krakensec.ca/',
              projectsummary:'Security services business website designed to build trust, highlight expertise, and generate leads.',
              projecthosting:'Pressable',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','https://bricksbuilder.io/wp-content/uploads/2023/07/bricks-logo.svg']
            },
            {
              projectimg:'../img/innovativelightsiowa.jpg',
              projecttitle:'Innovative Lights Iowa',
              projecttype:'Outdoor Lighting Website',
              projectyear:'2026',
              projectposition:'Lead Developer / Project Manager',
              projectlink:'https://innovativelightsiowa.com/',
              projectsummary:'Outdoor lighting company website focused on product presentation, local service positioning, and lead generation.',
              projecthosting:'Pressable',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','https://bricksbuilder.io/wp-content/uploads/2023/07/bricks-logo.svg']
            },
            {
              projectimg:'../img/titanlogix.jpg',
              projecttitle:'Titan Logix',
              projecttype:'Industrial Measurement Website',
              projectyear:'2026',
              projectposition:'Lead Developer / Project Manager',
              projectlink:'https://titanlogix.com/',
              projectsummary:'Industrial technology business website built to explain complex products and reinforce technical credibility.',
              projecthosting:'Pressable',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','https://bricksbuilder.io/wp-content/uploads/2023/07/bricks-logo.svg']
            },
            {
              projectimg:'../img/raincoastelectric.jpg',
              projecttitle:'Raincoast Electric',
              projecttype:'Electrical Services Website',
              projectyear:'2026',
              projectposition:'Lead Developer / Project Manager',
              projectlink:'https://raincoastelectric.ca/',
              projectsummary:'Electrical services company website focused on local trust, service clarity, and customer enquiries.',
              projecthosting:'Pressable',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','https://bricksbuilder.io/wp-content/uploads/2023/07/bricks-logo.svg']
            },
            {
              projectimg:'../img/expresselectricinc.jpg',
              projecttitle:'Express Electric Inc',
              projecttype:'Electrical Services Website',
              projectyear:'2026',
              projectposition:'Lead Developer / Project Manager',
              projectlink:'https://expresselectricinc.ca/',
              projectsummary:'Electrical contracting business website designed around service pages, credibility, and stronger lead capture.',
              projecthosting:'Pressable',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','https://bricksbuilder.io/wp-content/uploads/2023/07/bricks-logo.svg']
            },
            {
              projectimg:'../img/xcessive.jpg',
              projecttitle:'Xcessive',
              projecttype:'Vehicle Graphics Website',
              projectyear:'2026',
              projectposition:'Lead Developer / Project Manager',
              projectlink:'https://xcessive.ca/',
              projectsummary:'Vehicle graphics and branding business website designed to showcase work and attract commercial leads.',
              projecthosting:'Pressable',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','https://bricksbuilder.io/wp-content/uploads/2023/07/bricks-logo.svg']
            },
            {
              projectimg:'../img/astorialighting.jpg',
              projecttitle:'Astoria Lighting',
              projecttype:'Permanent Lighting Website',
              projectyear:'2026',
              projectposition:'Lead Developer / Project Manager',
              projectlink:'https://astorialighting.ca/',
              projectsummary:'Permanent lighting business website focused on premium branding, product storytelling, and conversion.',
              projecthosting:'Pressable',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','https://bricksbuilder.io/wp-content/uploads/2023/07/bricks-logo.svg']
            },
            {
              projectimg:'../img/halocustomlighting.jpg',
              projecttitle:'Halo Custom Lighting',
              projecttype:'Outdoor Lighting Website',
              projectyear:'2026',
              projectposition:'Lead Developer / Project Manager',
              projectlink:'https://halocustomlighting.com/',
              projectsummary:'Custom lighting company website focused on premium positioning, service clarity, and customer enquiry flow.',
              projecthosting:'Pressable',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','https://bricksbuilder.io/wp-content/uploads/2023/07/bricks-logo.svg']
            },
            {
              projectimg:'../img/vit.jpg',
              projecttitle:'Vitalis Health',
              projecttype:'Healthcare Services Website',
              projectyear:'2025',
              projectposition:'Lead Developer',
              projectlink:'https://vitalis.health/',
              projectsummary:'Healthcare provider website focused on patient trust, service clarity, and appointment-led conversion.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/us.jpg',
              projecttitle:'Better Days US',
              projecttype:'Healthcare Services Website',
              projectyear:'2025',
              projectposition:'Lead / In-house Developer',
              projectlink:'https://betterdays.us/',
              projectsummary:'Healthcare services website focused on patient support, care messaging, and easy enquiry conversion.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/uk.jpg',
              projecttitle:'Better Days UK',
              projecttype:'Healthcare Services Website',
              projectyear:'2023 - 25',
              projectposition:'Lead / In-house Developer',
              projectlink:'https://betterdays.uk/',
              projectsummary:'Healthcare brand website designed around accessibility, service clarity, and patient-focused communication.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/nz.jpg',
              projecttitle:'Better Days NZ',
              projecttype:'Healthcare Services Website',
              projectyear:'2023 - 25',
              projectposition:'Lead / In-house Developer',
              projectlink:'https://betterdays.nz/',
              projectsummary:'Healthcare services website built for trust, service visibility, and a clearer patient journey.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/br.jpg',
              projecttitle:'Better Rehab AU',
              projecttype:'Healthcare Services Website',
              projectyear:'2023 - 25',
              projectposition:'Lead / In-house Developer',
              projectlink:'https://betterrehab.com.au/',
              projectsummary:'Rehabilitation services website focused on care messaging, trust, and conversion for new enquiries.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/six.jpg',
              projecttitle:'Sixgun',
              projecttype:'Digital Marketing Website',
              projectyear:'2023',
              projectposition:'Lead Developer',
              projectlink:'https://sixgun.com.au/',
              projectsummary:'Digital marketing business website focused on brand visibility, service positioning, and lead generation.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/grey.jpg',
              projecttitle:'Grey Legal',
              projecttype:'Corporate Lawyer Website',
              projectyear:'2022',
              projectposition:'Lead Developer',
              projectlink:'https://www.greylegal.com.au/',
              projectsummary:'Law firm website focused on professionalism, trust, and clear service information for prospective clients.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/alpha.jpg',
              projecttitle:'Alpha Car Hire',
              projecttype:'Corporate Website',
              projectyear:'2022',
              projectposition:'Lead Frontend Developer',
              projectlink:'https://alphacarhire.com.au/',
              projectsummary:'Car hire company website structured around booking ease, service transparency, and customer conversion.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','https://surniaulula.com/wp-content/uploads/2018/09/wp-bakery-logo-1200x1200-cropped.jpg']
            },
            {
              projectimg:'../img/ca.jpg',
              projecttitle:'College Australia',
              projecttype:'School Website',
              projectyear:'2022',
              projectposition:'Lead Developer',
              projectlink:'https://collegeaustralia.edu.au/',
              projectsummary:'Education and training website focused on course clarity, student engagement, and institutional credibility.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/kode.jpg',
              projecttitle:'Kode <br>Access',
              projecttype:'E-Commerce Website',
              projectyear:'2022',
              projectposition:'Lead Developer',
              projectlink:'https://kodeaccess.com.au/',
              projectsummary:'Access solutions and hardware business website focused on product browsing, trust, and enquiry conversion.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/sengs.jpg',
              projecttitle:'SENGS <br>Sales & Service',
              projecttype:'Informative E-Commerce Level Website',
              projectyear:'2022',
              projectposition:'Lead Developer',
              projectlink:'https://sengs.com.au/',
              projectsummary:'Service and product business website focused on navigation, trust, and smoother customer discovery.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/dbos.jpg',
              projecttitle:'Dynamic Business Outsourcing Solutions',
              projecttype:'Corporate Website',
              projectyear:'2021',
              projectposition:'Lead Developer',
              projectlink:'https://dbos.com.au/',
              projectsummary:'Business outsourcing and consulting website designed to communicate services, expertise, and lead generation.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square','fab fa-elementor']
            },
            {
              projectimg:'../img/mnski.jpg',
              projecttitle:'Mineski Global',
              projecttype:'Corporate Website',
              projectyear:'2019',
              projectposition:'Lead Developer',
              projectlink:'https://www.mineskiglobal.com/',
              projectsummary:'Corporate website for Mineski Global, focused on presenting the company, its services, and its digital presence.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square']
            },
            {
              projectimg:'../img/crbn.jpg',
              projecttitle:'CarbonTrack UK',
              projecttype:'Corporate Website',
              projectyear:'2020',
              projectposition:'Lead Developer',
              projectlink:'https://carbontrackuk.co.uk/',
              projectsummary:'Sustainability and carbon management website focused on trust, clarity, and business credibility.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square']
            },
            {
              projectimg:'../img/dqtsi.jpg',
              projecttitle:'DynaQuest',
              projecttype:'Corporate Website',
              projectyear:'2020',
              projectposition:'Lead Developer',
              projectlink:'https://dqtsi.com/',
              projectsummary:'Corporate business website built around clearer messaging, stronger brand presence, and service positioning.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square']
            },
            {
              projectimg:'../img/sit.jpg',
              projecttitle:'Situp PH',
              projecttype:'Informative Website',
              projectyear:'2019',
              projectposition:'Lead Developer',
              projectlink:'https://dqtsi.com/',
              projectsummary:'Informational brand website designed to improve clarity, communication, and audience engagement.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square']
            },
            {
              projectimg:'../img/sha.jpg',
              projecttitle:'ShawarmaHouse PH',
              projecttype:'Informative Website',
              projectyear:'2018',
              projectposition:'Lead Developer',
              projectlink:'https://www.shawarmahouseph.com/',
              projectsummary:'Restaurant website focused on menu clarity, convenience, and stronger customer engagement.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square']
            },
            {
              projectimg:'../img/tgs.jpg',
              projecttitle:'The Greencross Saga',
              projecttype:'Informative Website',
              projectyear:'2018',
              projectposition:'Lead Developer',
              projectlink:'https://www.thegreencrosssaga.com/',
              projectsummary:'Informational website built around storytelling, readability, and clearer brand communication.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square']
            },
            {
              projectimg:'../img/comark.jpg',
              projecttitle:'Comark PH',
              projecttype:'E-Commerce Website',
              projectyear:'2018',
              projectposition:'Lead Developer',
              projectlink:'https://comark.com.ph/',
              projectsummary:'Retail business website designed to improve product visibility and customer browsing experience.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square']
            },
            {
              projectimg:'../img/tyd.jpg',
              projecttitle:'TYD Automotive AU',
              projecttype:'E-Commerce Website',
              projectyear:'2018',
              projectposition:'Lead Developer',
              projectlink:'https://tydautomotive.com.au/',
              projectsummary:'Automotive business website focused on product clarity, browsing ease, and stronger customer conversion.',
              projecthosting:'Apache / cPanel',
              projectstack:['fab fa-wordpress','fab fa-php','fab fa-html5','fab fa-css3-alt','fab fa-sass','fab fa-bootstrap','fab fa-js-square']
            }
          ]
        },{
          tabcontentclass:'tab-pane ',
          tabcontentid:'projtabs-2',
          contents: [
            {
              projectimg:'../img/gep.jpg',
              projecttitle:'Gepstudies AU',
              projecttype:'Corporate Website',
              projectyear:'2019',
              projectposition:'Frontend Developer',
              projectlink:'https://www.gepstudies.com/'
            },{
              projectimg:'../img/maj.jpg',
              projecttitle:'Majestic Ventures Group',
              projecttype:'Corporate Website',
              projectyear:'2018',
              projectposition:'Frontend Developer',
              projectlink:'https://www.majesticventures.group/'
            },{
              projectimg:'../img/noac.jpg',
              projecttitle:'NOAC Consultant AU',
              projecttype:'Corporate Website',
              projectyear:'2018',
              projectposition:'Frontend Developer',
              projectlink:'https://www.noac.net.au/'
            }
          ]
        },{
          tabcontentclass:'tab-pane ',
          tabcontentid:'projtabs-3',
          contents: [
            {
              projectimg:'../img/gwf.jpg',
              projecttitle:'Global WebForce',
              projecttype:'Corporate Website',
              projectyear:'2017',
              projectposition:'Frontend Developer',
              projectlink:'https://www.globalwebforce.com/'
            }
          ]
        }
      ]
    },
    ctacontents: {
      title:'Feel free to reach out!',
      subtitle:'',
      contents: [
         {
          fontawesomeclass:'fas fa-mobile',
          contactlink:'tel:+63 905 426 9814',
          contactcontent:'+63 905 426 9814'
         },{
          fontawesomeclass:'fas fa-mail-bulk',
          contactlink:'mailto:juaniparafina@gmail.com',
          contactcontent:'juaniparafina@gmail.com'
         },{
          fontawesomeclass:'fab fa-linkedin',
          contactlink:'https://www.linkedin.com/in/juanito-llera-parafina-iii-4985301a5',
          contactcontent:'LinkedIn Profile'
         },{
          fontawesomeclass:'fab fa-facebook-square',
          contactlink:'https://www.facebook.com/thirdz.parafina',
          contactcontent:'Facebook Profile'
         }
      ]
    },
    footercontent: {
      text: "Design and Developed by Juanito Llera Parafina III",
    },
  })
};
</script>


